import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import TableSortLabel from '~/modules/common/components/ListTable/components/DataTable/components/TableSortLabel';

const useStyles = makeStyles(theme => ({
  tableCell: {
    flexGrow: 1,
    minWidth: 100,
    alignSelf: 'stretch',
    flexBasis: 100,
    marginLeft: theme.spacing(-1.5)
  },
  roleEditCell: {
    paddingLeft: theme.spacing(9)
  },
  userEditCell: {
    marginLeft: theme.spacing(-0.5)
  },
  tableCellFFOn: {
    ...theme.typography.subtitle2,
    marginLeft: theme.spacing(1)
  }
}));

export const ResourceRequestChartHeaderLeftItem = ({
  sort,
  onSortChange,
  isPsaRmpTaskAllocation1Enabled
}) => {
  const classes = useStyles();

  return (
    <>
      <TableSortLabel
        className={classNames({
          [classes.tableCell]: !isPsaRmpTaskAllocation1Enabled,
          [classes.tableCellFFOn]: isPsaRmpTaskAllocation1Enabled
        })}
        field="roleName"
        show
        active={sort && sort.field === 'roleName'}
        direction={sort && sort.direction && sort.direction.toLowerCase()}
        onClick={onSortChange}
      >
        {isPsaRmpTaskAllocation1Enabled ? (
          <FormattedMessage id="resourceRequestChartHeader.resourceRequests" />
        ) : (
          <div className={classes.roleEditCell}>
            <FormattedMessage id="resourceRequestChartHeader.role" />
          </div>
        )}
      </TableSortLabel>
      {!isPsaRmpTaskAllocation1Enabled && (
        <TableSortLabel
          className={classes.tableCell}
          field="userName"
          show
          active={sort && sort.field === 'userName'}
          direction={sort && sort.direction && sort.direction.toLowerCase()}
          onClick={onSortChange}
        >
          <div className={classes.userEditCell}>
            <FormattedMessage id="resourceRequestChartHeader.resource" />
          </div>
        </TableSortLabel>
      )}
    </>
  );
};

ResourceRequestChartHeaderLeftItem.propTypes = {
  sort: PropTypes.object,
  onSortChange: PropTypes.func,
  isPsaRmpTaskAllocation1Enabled: PropTypes.bool
};

export default ResourceRequestChartHeaderLeftItem;
